const MESSAGE = {
    "ERR_BAD_REQUEST": "Permission access denied",
    "ERR_NETWORK": "Connection problems",
    "ERR_CANCELED": "Connection canceled"
};

export const CUSTOM_INTERCEPTOR = {
    MESSAGE
};